var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8566 4H11.1442C7.19857 4 4 7.19857 4 11.1442V20.8566C4 24.8022 7.19857 28.0008 11.1442 28.0008H20.8566C24.8022 28.0008 28.0008 24.8022 28.0008 20.8566V11.1442C28.0008 7.19857 24.8022 4 20.8566 4Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.3389C18.9456 21.3389 21.3335 18.951 21.3335 16.0054C21.3335 13.0598 18.9456 10.6719 16 10.6719C13.0544 10.6719 10.6665 13.0598 10.6665 16.0054C10.6665 18.951 13.0544 21.3389 16 21.3389Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5536 10.6687C23.3919 10.6687 24.0715 9.98909 24.0715 9.15075C24.0715 8.31242 23.3919 7.63281 22.5536 7.63281C21.7152 7.63281 21.0356 8.31242 21.0356 9.15075C21.0356 9.98909 21.7152 10.6687 22.5536 10.6687Z",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.9286eb1df05e303002ebee4696c5767d.svg";
export { ForwardRef as ReactComponent };